import ModalTemplate from "../../components/ModalTemplate/ModalTemplate";
import {documentIcon} from "../../components/Icon/Icon";
import Button from "../../components/Button/Button";
import {useFormik} from "formik";
import * as Yup from "yup";
import Input from "../../components/Input/Input";

const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    color: Yup.string().required('Color is required'),
    description: Yup.string()
})


const DocumentModal = ({document, onClose, onSubmit}) => {

    const formik = useFormik({
        initialValues: {
            id: document.id,
            name: document.name || "",
            color: document.color,
            description: document.description || ""
        },
        validationSchema,
        onSubmit: values => onSubmit(values)
    })

    return(
        <ModalTemplate
            onClose={onClose}
            title={formik.values.id ? formik.values.prevName : "New Document"}
            icon={documentIcon}
            footerActions={
                <>
                    <Button
                        type="submit"
                        form="documentModalForm"
                    >
                        Save
                    </Button>
                    <Button
                        onClick={onClose}
                        variant="secondary"
                    >
                        Cancel
                    </Button>
                </>
            }
        >
            <form
                id="documentModalForm"
                onSubmit={formik.handleSubmit}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        formik.handleSubmit();
                    }
                }}
            >
                <Input
                    label="Name"
                    name="name"
                    formik={formik}
                />
                <Input
                    type="color"
                    label="Color"
                    name="color"
                    formik={formik}
                />
                <Input
                    name="description"
                    label="Description"
                    formik={formik}
                    required={false}
                    type="text"
                />
            </form>
        </ModalTemplate>
    )
}

export default DocumentModal;